var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.prefixClass, style: _vm.styles }, [
    _c(
      "div",
      {
        class: [_vm.prefixClass + "__head", "is-" + _vm.currentStatus]
      },
      [
        _c("div", { class: _vm.prefixClass + "__line" }, [
          _c("i", { class: _vm.prefixClass + "__line-inner" })
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.prefixClass + "__icon" }, [
          _vm.showIcon
            ? _c("div", { class: _vm.prefixClass + "__icon-inner" }, [
                _vm._v(_vm._s(_vm.index + 1))
              ])
            : _c("div", { class: _vm.iconClasses })
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { class: _vm.prefixClass + "__main" }, [
      _c(
        "div",
        { class: [_vm.prefixClass + "__title", "is-" + _vm.currentStatus] },
        [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [_vm.prefixClass + "__description", "is-" + _vm.currentStatus]
        },
        [_vm._t("description", [_vm._v(_vm._s(_vm.description))])],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a858e78", { render: render, staticRenderFns: staticRenderFns })
  }
}